export function iconFor(name) {
  const icons = {
    doctor: "👨‍⚕️",
    incident: "⚠️",
    treatment: "💊",
    completedTreatment: "📋",
    patientVisits: "🩺",    
    pet: "🐾",
    product: "📦",
    vaccination: "💉",
    vaccinationGiven: "💉",
    visitingPet: "🐾"
  };

  return icons[name] || "📁";
}

export function formatTitle(name) {
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export function formatField(field) {
  return field
    .replace(/([A-Z])/g, " $1")        // insert spaces before capital letters
    .replace(/^./, str => str.toUpperCase()); // capitalize first letter
}
